<template>
  <sfs-base-list-filter
    title="Search Work Order History"
    :table-name="tableName"
    :applied-filters="appliedFilters"
    :displayed-columns="[]"
    :available-columns="[]"
    @filters-applied="onFiltersApplied"
    @filters-reset="onDefaultPresetApplied"
    @filter-cleared="onFilterCleared"
    :column-picker="false"
    :advanced-filter="false"
  >
    <template #quick-filters>
      <b-form-group
        label="Search fields for Data"
        label-for="history-quick-filter-text"
        label-sr-only
      >
        <b-input-group>
          <b-form-input
            id="history-quick-filter-text"
            v-model="filters.text"
            type="text"
            placeholder="Filter by Work Order Number, Service or Description"
            @keydown.enter.native="applyFilters"
          />
          <template #append>
            <b-button
              id="history-quick-filter-apply-button"
              @click="applyFilters"
              variant="primary"
            >
              <i class="fa fa-search" />
            </b-button>
          </template>
        </b-input-group>
      </b-form-group>
    </template>
  </sfs-base-list-filter>
</template>

<script>
import listFilterMixin from '@/mixins/listFilterMixin';
import { WORK_ORDER_HISTORY_TABLE_NAME } from '@/constants/workOrders';

export default {
  name: 'WorkOrderHistoryListFilter',
  mixins: [listFilterMixin],
  data() {
    return {
      tableName: WORK_ORDER_HISTORY_TABLE_NAME,
    };
  },
  mounted() {
    this.applyFilters();
  },
  methods: {
    onDefaultPresetApplied() {
      this.filters = {};
      this.applyFilters();
    },
  },
};
</script>
